<ng-container
	*ngIf="{
		selectDisabledAttributes: selectDisabledAttributes$ | async
	} as vm">
	<hmf-selector
		id="color-panel-button"
		[contained]="true"
		[selector]="'rectangular'"
		[width]="'100%'"
		[ariaLabel]="'Open color panel'"
		(click)="openModal()">
		<div
			ngProjectAs="rectangularSelectorBody"
			class="color-selector hmf-display-flex hmf-align-items-center hmf-justify-content-between">
			<div class="hmf-m-xxs hmf-display-flex hmf-align-items-center">
				<img
					*ngIf="selectedColor"
					class="hmf-round-radius hmf-mr-xs border-secondary-subtle-static"
					alt="Color swatch"
					height="36px"
					width="36px"
					[src]="selectedColorThumbnailImageSource"
					(error)="imageErrorFallback($event)" />
				<span class="hmf-header-xs hmf-mr-xxxs label-base">
					{{ selectedColor ? 'Color' : 'Select Color' }}</span
				>
				<span class="hmf-header-bold-xs label-base"> {{ selectedColor?.value }}</span>
			</div>
			<div class="hmf-display-flex hmf-align-items-center">
				<span
					*ngIf="
						selectedColor &&
						vm.selectDisabledAttributes &&
						vm.selectDisabledAttributes[selectedColor?.name] &&
						!vm.selectDisabledAttributes[selectedColor?.name].includes(
							selectedColor.value
						)
					"
					class="hmf-body-s label-disabled"
					>Not Available</span
				>
				<homefield-icon
					width="22px"
					height="22px"
					alt="arrow right"
					name="chevron-right"
					class="hmf-mr-xxs">
				</homefield-icon>
			</div>
		</div>
	</hmf-selector>

	<hmf-drawer id="color-selection-panel" [direction]="drawerDirection()">
		<div class="hmf-display-flex hmf-flex-column selection-panel-content-wrapper">
			<div class="hmf-pl-s hmf-pr-m">
				<h2 class="hmf-header-bold-s hmf-p-m hmf-text-align-center">Select a Color</h2>
			</div>
			<div class="hmf-display-flex hmf-flex-column hmf-flex-grow overflow-auto">
				<div class="hmf-pl-s hmf-pr-m overflow-auto hmf-flex-m-grow">
					<ng-container
						*ngFor="let attributesOption of colorAttributeData; trackBy: trackByFn">
						<hmf-selector
							id="color-option"
							class="hmf-mt-xs"
							[unavailable]="
								vm.selectDisabledAttributes &&
								vm.selectDisabledAttributes[attributesOption?.name] &&
								!vm.selectDisabledAttributes[attributesOption?.name].includes(
									attributesOption.value
								)
							"
							[contained]="false"
							[selector]="'rectangular'"
							[circleVariant]="false"
							[dblBorder]="false"
							[width]="'100%'"
							[selected]="attributesOption.value === selectedColor?.value"
							[ariaLabel]="attributesOption.value"
							(click)="selectedAttribute(attributesOption)">
							<div
								ngProjectAs="rectangularSelectorBody"
								class="hmf-display-flex hmf-justify-content-between">
								<div class="hmf-display-flex hmf-align-items-center hmf-p-xxxs">
									<img
										class="hmf-soft-radius"
										height="60px"
										width="60px"
										alt="{{ attributesOption.value }}"
										[src]="setColorImageSrc(attributesOption.value)"
										(error)="imageErrorFallback($event)" />
									<span
										class="hmf-text-transform-none hmf-subheader-m-l hmf-subheader-m hmf-ml-xs hmf-text-align-left label-base"
										[ngClass]="{
											'hmf-subheader-bold-m-l hmf-subheader-bold-m':
												attributesOption.value === selectedColor?.value
										}"
										>{{ attributesOption.value }}</span
									>
								</div>
								<ng-container
									*ngIf="
										(colorToResolvedSkuMap$ | async)[attributesOption.value]
											?.prices as price;
										else nonResolvedPrice
									">
									<div
										*ngIf="price.mapPriceIndicator !== 1"
										class="hmf-header-s hmf-display-flex hmf-align-items-center hmf-mr-xs label-base"
										[ngClass]="{
											'label-sale':
												price.offerPrice < price.listPrice ||
												price.offerPrice?.toString().includes('.97')
										}">
										{{ price.offerPrice | currency }}
									</div>
									<div
										*ngIf="price.mapPriceIndicator === 1"
										class="hmf-header-s hmf-display-flex hmf-align-items-center hmf-mr-xs label-base">
										See Price In Cart
									</div>
								</ng-container>

								<ng-template #nonResolvedPrice>
									<div
										*ngIf="!attributesOption.prices.emptyPrice"
										class="hmf-header-s hmf-display-flex hmf-align-items-center hmf-mr-xs label-base"
										[ngClass]="{
											'label-sale':
												attributesOption.prices.minOfferPrice <
													attributesOption.prices.minListPrice ||
												attributesOption.prices.minOfferPrice
													?.toString()
													.includes('.97')
										}">
										{{ attributesOption.prices.minOfferPrice | currency }}
										<span
											class="hmf-pl-xxxs price-range label-base"
											*ngIf="
												attributesOption.prices.maxOfferPrice >
												attributesOption.prices.minOfferPrice
											"
											[ngClass]="{
												'label-sale':
													attributesOption.prices.minOfferPrice <
														attributesOption.prices.minListPrice ||
													attributesOption.prices.minOfferPrice
														?.toString()
														.includes('.97')
											}">
											-
											{{ attributesOption.prices.maxOfferPrice | currency }}</span
										>
									</div>
									<div
										*ngIf="attributesOption.prices.emptyPrice"
										class="hmf-header-s hmf-display-flex hmf-align-items-center hmf-mr-xs label-base">
										See Price In Cart
									</div>
								</ng-template>
							</div>
						</hmf-selector>
					</ng-container>
				</div>

				<div class="hmf-p-s hmf-elevated-up-shadow hmf-display-none hmf-display-m-block">
					<button
						hmf-button
						tabindex="0"
						[variant]="'primary'"
						[text]="'Save'"
						[size]="'medium'"
						class="width100"
						(click)="closeModal()"
					>
						Save
					</button>
				</div>
			</div>
		</div>
	</hmf-drawer>
</ng-container>
